import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
var defaultMin = 0;
var defaultMax = 10000000;
var defaultStep = 2500;
export default function Slider(_a) {
    var value = _a.value, _b = _a.step, step = _b === void 0 ? defaultStep : _b, _c = _a.min, min = _c === void 0 ? defaultMin : _c, _d = _a.max, max = _d === void 0 ? defaultMax : _d, onChange = _a.onChange, fieldId = _a.fieldId, label = _a.label;
    var adjustedMax = useMemo(function () {
        var range = max - min;
        var steps = Math.ceil(range / step);
        return min + steps * step;
    }, [min, max, step]);
    var clampedValue = Math.min(value, max);
    return (_jsx("input", { className: "range", type: "range", step: step, min: min, max: adjustedMax, value: clampedValue, onChange: onChange, autoComplete: "off", "aria-labelledby": fieldId, "aria-label": "".concat(label || "Currency input", " slider"), "aria-valuemax": max, "aria-valuenow": clampedValue }));
}
